import { useEffect, useRef, useState } from "react";
import { TableOfContentItem } from "./type";

export function useTableOfContent(tableOfContent: TableOfContentItem[], body: string) {
  const [idReading, setIdReading] = useState("");

  const timelineRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const headings =
      tableOfContent.length > 0
        ? document.getElementById("kdotdev-slug-content")?.querySelectorAll(tableOfContent[0].levels.join(", "))
        : undefined;

    if (!headings) return;
    // FireFoxではwindow.innerHeightがバグって100以下になることがあるので、正しい値がわからないときはlandscapeモードを想定しスマホ画面の最小の横幅と同じ値にする
    // https://caniuse.com/mdn-api_window_innerheighthttps://caniuse.com/mdn-api_window_innerheight
    const innerHeight = window.innerHeight <= 100 ? 390 : window.innerHeight;
    const options = {
      root: null,
      // 本来は画面サイズの矩形との交差を検知するが、rootMarginにマイナス値を持たせることでその分小さくなった矩形との交差を検知する
      // 57はヘッダーの大きさ
      // (innerHeight - 100)はもともと(innerHeight - 58)だったが、矩形が小さいと検知できないっぽいので100にした
      rootMargin: `-57px 0px -${innerHeight - 100}px 0px`,
    };
    let element: HTMLElement | null = null;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const id = entry.target.querySelector("div:last-child")?.id;

        if (!id) return;

        if (entry.isIntersecting) {
          // 下方向へスクロールしてる時
          if (entry.intersectionRect.top != 57) {
            setIdReading(id);
            element = document.getElementById(`item-${id}`);
          }
          // 上方向へスクロールしてる時
          else {
            const findIndex = Array.from(headings).findIndex((el) => el.querySelector("div:last-child")?.id === id);

            if (findIndex - 1 >= 0) {
              const prevId = headings[findIndex - 1].querySelector("div:last-child")?.id ?? "";
              setIdReading(prevId);
              element = document.getElementById(`item-${prevId}`);
            }
          }

          if (!element || !timelineRef.current) return;

          const timelineHeight = timelineRef.current.clientHeight;
          const elementTop = element.offsetTop;
          const distanceToParent = elementTop - timelineRef.current.scrollTop;

          // elementが上に隠れてる
          // 15は調整
          if (distanceToParent < 15) {
            timelineRef.current.scrollTop = elementTop - timelineHeight / 2;
          }

          // elementが下に隠れてる
          if (distanceToParent > timelineHeight - 15) {
            timelineRef.current.scrollTop = elementTop - timelineHeight / 2;
          }
        }
      });
    }, options);

    headings.forEach((heading: Element) => {
      observer.observe(heading);
    });

    return () => {
      headings.forEach((heading: Element) => {
        observer.unobserve(heading);
      });
    };
  }, [tableOfContent, body]);

  return [idReading, timelineRef] as const;
}
